<template>
  <div class="container">
    <Head v-if="meta.title" v-bind:meta="meta"></Head>
    <Header></Header>
    <Navigation></Navigation>
    <Breadcrumbs
      v-if="breadcrumbs"
      v-bind:breadcrumbs="breadcrumbs"
    ></Breadcrumbs>
    <AllTagsContent v-if="tags.length == total_tags" />
    <Footer></Footer>
  </div>
</template>

<script>
// libraries
import axios from "axios";

// components

import Head from "@/components/Common/Head.vue";
import Header from "@/components/Header/Header.vue";
import AllTagsContent from "@/components/AllTags/AllTagsContent.vue";
import Navigation from "@/components/Common/Navigation.vue";
import Footer from "@/components/Footer/Footer.vue";
import Breadcrumbs from "@/components/Common/Breadcrumbs.vue";
import NProgress from "nprogress";

export default {
  name: "AllTags",
  props: ['apiCall'],
  components: {
    Head,
    Header,
    Navigation,
    AllTagsContent,
    Breadcrumbs,
    Footer,
  },
  data() {
    return {
      page_title: "",
      parent_title: {
        title: "Etykiety",
        href: "/etykiety",
      },
      component_title: this.name,
      meta: {
        url: window.location.href,
        description: "",
        title: "",
        og_type: "website",
        og_image: "",
      },
      breadcrumbs: {
        parent_title: "Etykiety",
        parent_uri: "/etykiety",
        self_title: "",
        self_uri: window.location.href,
      },
      page: 1,
      total_tags: 0,
      processed_tags: 0,
      tags: [],
    };
  },
  methods: {
    fetchData() {
      axios
        .get(
          this.$config.API_PATH + this.apiCall + "?page=" + this.page
        )
        .then((_resp) => {
          this.total_tags = _resp.headers["omeka-total-results"];

          _resp.data.forEach((_t) => {
            this.tags.push(_t);
          });

          if (this.tags.length != this.total_tags) {
            this.page++;
            this.fetchData();
          }

          // sorting
          this.tags.sort(function (a, b) {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return textA < textB ? -1 : textA > textB ? 1 : 0;
          });

          setTimeout(function () {
            NProgress.done();
          }, 500);
        })
        .catch((error) => {
          this.$router.push({
              name: "NotFound",
            });
        });
    },
  },
  created() {
    NProgress.start();
    this.fetchData();
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/AllTags/AllTags.vue